import type { SimplifyOpts } from '@elara/core/introspection';

import type { CollapsibleBlockProps } from './collapsible-block.js';

import { isLlmJsonString, tryReadJson } from '@elara/core/utils';

import { CollapsibleBlock } from './collapsible-block.js';
import { JsonDump } from './json-dump.js';

export type CollapsibleDumpProps = Omit<CollapsibleBlockProps, 'children'> & {
  dump: unknown;
  simplified?: true | SimplifyOpts;
};

export function CollapsibleDump({ dump, className, simplified, ...collapsibleProps }: CollapsibleDumpProps) {
  let cleanerDump = isLlmJsonString(dump) ? tryReadJson(dump) : dump;
  return (
    <CollapsibleBlock {...collapsibleProps} className={className} onCopy={() => JSON.stringify(dump, null, 2)}>
      <JsonDump data={cleanerDump ?? dump} simplified={simplified} />
    </CollapsibleBlock>
  );
}
